import { UnitConverter } from '../base/UnitConverter';
import { UnitOptions } from '../constants/unit.options';

export class PowerUnitConverter extends UnitConverter<
  (typeof UnitOptions)['Power'][number]['value']
> {
  // 싱글턴 인스턴스
  private static instance: PowerUnitConverter;

  private constructor() {
    super();
  }

  static getInstance(): PowerUnitConverter {
    if (!PowerUnitConverter.instance) {
      PowerUnitConverter.instance = new PowerUnitConverter();
    }
    return PowerUnitConverter.instance;
  }

  protected units = [
    'nanowatt (nW)',
    'microwatt (μW)',
    'milliwatt (mW)',
    'deciwatt (dW)',
    'watt (W)',
    'kilowatt (kW)',
    'megawatt (MW)',
    'gigawatt (GW)',
    'terawatt (TW)',
  ] as const;

  protected unitToBase = {
    'nanowatt (nW)': 1e-9,
    'microwatt (μW)': 1e-6,
    'milliwatt (mW)': 1e-3,
    'deciwatt (dW)': 1e-1,
    'watt (W)': 1,
    'kilowatt (kW)': 1e3,
    'megawatt (MW)': 1e6,
    'gigawatt (GW)': 1e9,
    'terawatt (TW)': 1e12,
  };
}
